import { gql } from "@apollo/client"

export const GET_WHW_SPONSORS = gql`
  query {
    sponsors {
      globalPartners {
        label
        data {
          id
          description
          imageUrl
          redirectionUrl
          sponsorCategory
        }
      }
      mediaSponsors {
        label
        data {
          id
          description
          imageUrl
          redirectionUrl
          sponsorCategory
        }
      }
      partners {
        label
        data {
          id
          description
          imageUrl
          redirectionUrl
          sponsorCategory
        }
      }
      sponsors {
        label
        data {
          id
          description
          imageUrl
          redirectionUrl
          sponsorCategory
        }
      }
    }
  }
`
